export const isWarehouse = (pointType?: unknown): pointType is 'warehouse' => pointType === 'warehouse'
